import { render, staticRenderFns } from "./EvidencePanel.vue?vue&type=template&id=7023f438&scoped=true&"
import script from "./EvidencePanel.vue?vue&type=script&lang=js&"
export * from "./EvidencePanel.vue?vue&type=script&lang=js&"
import style0 from "./EvidencePanel.vue?vue&type=style&index=0&id=7023f438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7023f438",
  null
  
)

export default component.exports